import Vue from 'vue'
import VueRouter from 'vue-router'
import SecurityRoutes from '../modules/Security/Routes'
import HomeRoutes from '../modules/Home/Routes'
import D4DRoutes from '../modules/D4D/Routes'
import JobShadowRoutes from '../modules/JobShadow/Routes'
import BeEntrepreneurshipRoutes from '../modules/BeEntrepreneurship/Routes'
import {Storage} from '../core/Utils'
import NotFound from '../core/Pages/404.vue'

Vue.use(VueRouter)

let routes = [];

let routes404 = [
    {
        // catch all 404 - define at the very end
        path: "*",
        component: NotFound,
        meta: { authRequired: false, showNavigation: false, showNavigationInfo: false, hideSideNavigation: true }
    }
];

routes = routes.concat(SecurityRoutes, HomeRoutes, D4DRoutes, JobShadowRoutes , BeEntrepreneurshipRoutes, routes404);

const router = new VueRouter({
    routes,
    scrollBehavior() {
        return {x: 0, y: 0}
    }
})

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const loggedIn = !!Storage.getUser().id
    const isGuest = !!Storage.getGuest().isGuest
    if (to.meta.authRequired && (!loggedIn && !isGuest)) {
        return next({name: 'Login'})
    } else if (to.name === 'Login' && loggedIn) {
        return next({name: 'home'})
    } else {
        next()
    }
})

export default router
